import { render, staticRenderFns } from "./DexHeaderNavItem.vue?vue&type=template&id=7adc3ee9&"
import script from "./DexHeaderNavItem.vue?vue&type=script&lang=js&"
export * from "./DexHeaderNavItem.vue?vue&type=script&lang=js&"
import style0 from "./DexHeaderNavItem.vue?vue&type=style&index=0&id=7adc3ee9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports